import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

interface AppConfig {
  type: 'empresa' | 'pessoal';
  name: string;
  features: string[];
}

interface ConfigContextType {
  config: AppConfig;
  loading: boolean;
  hasFeature: (feature: string) => boolean;
}

const DEFAULT_CONFIG: AppConfig = {
  type: 'empresa',
  name: 'Ledger',
  features: ['funcionarios', 'impostos', 'contas-pagar', 'contas-receber'],
};

const ConfigContext = createContext<ConfigContextType>({
  config: DEFAULT_CONFIG,
  loading: true,
  hasFeature: () => true,
});

export function ConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<AppConfig>(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get<AppConfig>('/api/config')
      .then((res) => setConfig(res.data))
      .catch(() => setConfig(DEFAULT_CONFIG))
      .finally(() => setLoading(false));
  }, []);

  const hasFeature = (feature: string) => config.features.includes(feature);

  return (
    <ConfigContext.Provider value={{ config, loading, hasFeature }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
